import { get, post } from '@/Api';
import { SelectItem } from '@/Models/Other/SelectItem';
import { Department } from '@/Models/Tables/Department';

const name = 'Department';

function getUrl(url: string) {
    return `${name}/${url}`;
}
export function getViews(): Promise<Department[]> {
    return get(getUrl("getViews"));
}
export function add(data: Department): Promise<Department> {
    return post(getUrl("add"), data);
}
export function upd(data: Department): Promise<Department> {
    return post(getUrl("upd"), data);
}
export function del(id: number): Promise<number> {
    return get(getUrl("del"), { id });
}
export function getDepartmentSelectItems(): Promise<SelectItem[]> {
    return get(getUrl("getSelectItems"));
}